document.addEventListener('DOMContentLoaded', function () {
    startWatchingUpsellWidget();
});

function startWatchingUpsellWidget() {
    const intervalId = setInterval(checkUpsellWidget, 100);

    setTimeout(() => {
        clearInterval(intervalId);
    }, 1000000);
}

function checkUpsellWidget() {
    const products = document.querySelectorAll('[data-essential-upsell-element="product"]');
    const filteredProducts = Array.from(products).filter(product => {
        const firstDiv = product.querySelector('div:first-of-type');
        return firstDiv && firstDiv.querySelector('a');
    });
    if (filteredProducts.length > 0) {
        const isCartPage = window.location.href.includes('cart');
        const isMobilePage = window.innerWidth < 768;

        filteredProducts.forEach((product) => {
            const productsContainer = product.closest('[data-essential-upsell-element="products"]');
            if (productsContainer.getAttribute('data-skin-applied') === 'true') {
                return;
            }
            productsContainer.setAttribute('data-skin-applied', 'true');
            productsContainer.innerHTML = '';
            productsContainer.appendChild(product);
            productsContainer.style.display = 'flex';

            product.style.flex = '1';
            product.style.height = isCartPage ? isMobilePage ? '270px' : '153px' : isMobilePage ? '270px' : '210px';
            product.style.paddingLeft = '0';
            product.style.paddingTop = '0';
            product.style.paddingRight = '0';
            product.style.alignItems = 'flex-start';

            const mainContainer = product.closest('[data-essential-upsell-element="container"]');
            mainContainer.style.width = '100%';
            if (isMobilePage) {
                if (isCartPage || mainContainer.closest('.cart-notification__links')) {
                    mainContainer.style.paddingBottom = '10px';
                } else {
                    mainContainer.remove();
                    document.querySelector('.variants-selector').insertAdjacentElement('afterend', mainContainer);
                    mainContainer.style.order = 8;
                    mainContainer.style.paddingTop = '0';
                }
            }

            const titleElement = product.querySelector('[data-essential-upsell-element="title"]');
            if (titleElement) {
                titleElement.remove();
            }

            const priceElement = product.querySelector('[data-essential-upsell-element="price"]');
            if (priceElement) {
                priceElement.remove();
            }

            const buttonContainer = product.querySelector('[data-essential-upsell-element="button-container"]');
            const button = product.querySelector('button');
            buttonContainer.style.display = 'flex';
            buttonContainer.style.flexDirection = 'column';
            buttonContainer.style.alignItems = 'flex-start';
            buttonContainer.style.gap = '4px';
            button.style.marginTop = '0';
            button.style.height = '46px';
            const image = product.querySelector('a');
            image.style.alignSelf = 'flex-start';

            if (isCartPage && !isMobilePage) {
                buttonContainer.style.alignSelf = 'center';
            } else {
                buttonContainer.style.flex = '1';
                buttonContainer.style.width = '169px';
                buttonContainer.style.height = '92px';
                buttonContainer.style.maxWidth = 'unset';
                buttonContainer.remove();
            }

            const imageContainer = product.querySelector('[data-essential-upsell-element="image-container"]');
            if (imageContainer) {
                imageContainer.style.width = '100px';
                imageContainer.style.height = '153px';
            }

            const contentDiv = product.querySelector('[data-essential-upsell-element="content"]');
            if (contentDiv) {
                const title = document.createElement('div');
                title.textContent = 'World of Books +Plus';
                title.style.fontSize = '16px';
                title.style.fontFamily = 'var(--wob-typography-font-body)';
                title.style.color = '#1D1D1D';
                title.style.lineHeight = '160%';
                title.style.fontWeight = '400';
                title.style.textAlign = 'left';
                contentDiv.appendChild(title);

                const newLines = [
                    '+ FREE book on us today! Under £5 Preloved only',
                    '+ 10% off all preloved orders all year',
                    '+ Surprise perks (50% off selected books)'
                ];

                // Create a new div for the lines
                const linesDiv = document.createElement('div');
                linesDiv.innerHTML = newLines.join('<br>');

                linesDiv.style.textAlign = 'left';
                linesDiv.style.fontFamily = 'var(--wob-typography-font-body)';
                linesDiv.style.color = 'var(--wob--grey-tint-1)';
                linesDiv.style.fontSize = '13px';
                linesDiv.style.lineHeight = '160%';
                linesDiv.style.fontWeight = '400';

                contentDiv.appendChild(linesDiv);

                const findOutMoreLink = document.createElement('a');
                findOutMoreLink.href = 'https://www.worldofbooks.com/en-gb/products/world-of-books-plus-1';
                findOutMoreLink.textContent = 'Find out more';
                findOutMoreLink.style.textDecoration = 'underline';
                findOutMoreLink.style.textUnderlineOffset = '0.3rem';
                findOutMoreLink.style.color = 'rgb(var(--color-link))';
                findOutMoreLink.style.display = 'flex';
                findOutMoreLink.style.alignItems = 'center';

                const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                svg.setAttribute('aria-hidden', 'true');
                svg.setAttribute('focusable', 'false');
                svg.setAttribute('class', 'icon icon-chevron');
                svg.setAttribute('width', '24');
                svg.setAttribute('height', '24');
                svg.setAttribute('viewBox', '0 0 24 24');
                svg.setAttribute('fill', 'none');
                svg.style.width = '16px';

                const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                path.setAttribute('d', 'M9 18L15 12L9 6');
                path.setAttribute('stroke', 'currentColor');
                path.setAttribute('stroke-width', '2');
                path.setAttribute('stroke-miterlimit', '3.8637');
                path.setAttribute('stroke-linecap', 'square');

                svg.appendChild(path);
                findOutMoreLink.appendChild(svg);
                contentDiv.appendChild(findOutMoreLink);

                const priceContainer = document.createElement('div');
                priceContainer.style.marginTop = '16px';
                priceContainer.style.width = '-webkit-max-content';

                const boldText = document.createElement('span');
                boldText.style.marginLeft = '6px'
                boldText.textContent = '£14.99 a year';
                boldText.style.fontFamily = 'var(--wob-typography-font-body-bold)';
                boldText.style.fontWeight = '400';
                boldText.style.color = '#1D1D1D';
                boldText.style.fontSize = '16px';
                priceContainer.appendChild(boldText);

                const form = document.createElement('form');
                form.method = 'post';
                form.action = '/en-gb/cart/add';
                form.id = 'product-form-template--24116462092561__main';
                form.acceptCharset = 'UTF-8';
                form.classList.add('form');
                form.enctype = 'multipart/form-data';
                form.setAttribute('novalidate', 'novalidate');
                form.setAttribute('data-type', 'add-to-cart-form');

                const formTypeInput = document.createElement('input');
                formTypeInput.type = 'hidden';
                formTypeInput.name = 'form_type';
                formTypeInput.value = 'product';

                const utf8Input = document.createElement('input');
                utf8Input.type = 'hidden';
                utf8Input.name = 'utf8';
                utf8Input.value = '✓';

                const productIdInput = document.createElement('input');
                productIdInput.type = 'hidden';
                productIdInput.name = 'id';
                productIdInput.value = '51264739344657';
                productIdInput.classList.add('product-variant-id');

                const productIdHiddenInput = document.createElement('input');
                productIdHiddenInput.type = 'hidden';
                productIdHiddenInput.name = 'product-id';
                productIdHiddenInput.value = '10338952151313';

                const sectionIdHiddenInput = document.createElement('input');
                sectionIdHiddenInput.type = 'hidden';
                sectionIdHiddenInput.name = 'section-id';
                sectionIdHiddenInput.value = 'template--24116462092561__main';

                const sellingPlanInput = document.createElement('input');
                sellingPlanInput.type = 'hidden';
                sellingPlanInput.name = 'selling_plan';
                sellingPlanInput.value = '12369232145';

                const sectionsInput = document.createElement('input');
                sectionsInput.type = 'hidden';
                sectionsInput.name = 'sections';
                sectionsInput.value = 'cart-notification-product,cart-notification-button,cart-icon-bubble';

                const sectionsUrlInput = document.createElement('input');
                sectionsUrlInput.type = 'hidden';
                sectionsUrlInput.name = 'sections_url';
                sectionsUrlInput.value = '/en-gb/products/world-of-books-plus-1';

                const productFormButtons = document.createElement('div');
                productFormButtons.classList.add('product-form__buttons');

                const submitButton = document.createElement('button');
                submitButton.id = 'ProductSubmitButton-template--24116462092561__main';
                submitButton.type = 'submit';
                submitButton.name = 'add';
                submitButton.classList.add('product-form__submit', 'button', 'button--fullwidth', 'button--primary');
                submitButton.style.background = 'var(--wob--green-2)';
                submitButton.style.color = 'rgb(var(--color-button-text))';
                submitButton.style.width = '160px';


                const buttonSpan = document.createElement('span');
                buttonSpan.textContent = 'Add To Basket';

                const loadingOverlay = document.createElement('div');
                loadingOverlay.classList.add('loading-overlay__spinner', 'hidden');

                const svgSpinner = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                svgSpinner.setAttribute('aria-hidden', 'true');
                svgSpinner.setAttribute('focusable', 'false');
                svgSpinner.classList.add('spinner');
                svgSpinner.setAttribute('viewBox', '0 0 66 66');
                svgSpinner.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

                const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
                circle.classList.add('path');
                circle.setAttribute('fill', 'none');
                circle.setAttribute('stroke-width', '6');
                circle.setAttribute('cx', '33');
                circle.setAttribute('cy', '33');
                circle.setAttribute('r', '30');

                svgSpinner.appendChild(circle);
                loadingOverlay.appendChild(svgSpinner);
                submitButton.appendChild(buttonSpan);
                submitButton.appendChild(loadingOverlay);
                productFormButtons.appendChild(submitButton);

                const errorMessageWrapper = document.createElement('div');
                errorMessageWrapper.classList.add('product-form__error-message-wrapper');
                errorMessageWrapper.setAttribute('role', 'alert');
                errorMessageWrapper.setAttribute('hidden', '');

                const errorSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                errorSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
                errorSvg.setAttribute('width', '24');
                errorSvg.setAttribute('height', '24');
                errorSvg.setAttribute('viewBox', '0 0 24 24');
                errorSvg.setAttribute('fill', 'none');

                const errorPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                errorPath.setAttribute('d', 'M12 16H12.01M12 8V12M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z');
                errorPath.setAttribute('stroke', '#BD0000');
                errorPath.setAttribute('stroke-width', '2');
                errorPath.setAttribute('stroke-miterlimit', '3.8637');
                errorPath.setAttribute('stroke-linecap', 'square');

                errorSvg.appendChild(errorPath);
                errorMessageWrapper.appendChild(errorSvg);

                const errorMessage = document.createElement('span');
                errorMessage.classList.add('product-form__error-message');
                errorMessageWrapper.appendChild(errorMessage);


                form.appendChild(formTypeInput);
                form.appendChild(utf8Input);
                form.appendChild(productIdInput);
                form.appendChild(productIdHiddenInput);
                form.appendChild(sectionIdHiddenInput);
                form.appendChild(sellingPlanInput);
                form.appendChild(sectionsInput);
                form.appendChild(sectionsUrlInput);
                form.appendChild(productFormButtons);
                form.appendChild(errorMessageWrapper);

                buttonContainer.innerHTML = '';
                buttonContainer.appendChild(priceContainer);
                buttonContainer.appendChild(form);

                form.addEventListener('submit', function (event) {
                    event.preventDefault();

                    const formData = new FormData(form);

                    fetch(form.action, {
                        method: form.method,
                        body: formData,
                        headers: {
                            'Accept': 'application/javascript',
                            'Accept-Language': 'en-US,en;q=0.9,hu;q=0.8,da;q=0.7',
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        credentials: 'include'
                    })
                        .then(response => response.json())
                        .then(data => {
                            if (isCartPage) {
                                window.location.reload();
                            } else {
                                document.querySelector('cart-notification').renderContents(data);
                            }
                        })
                        .catch((error) => { });
                });

                if (!isCartPage || isMobilePage) {
                    contentDiv.appendChild(buttonContainer);
                }
            }
        });
    }
}
